const appConfig = {
    apiPrefix: process.env.REACT_APP_SERVER,
    // apiPrefix: '/api',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: process.env.REACT_APP_PORTAL_URL,
    tourPath: '/',
    enableMock: false
}

export default appConfig